import * as yup from 'yup';

import { ObjectTypeBase } from '../../types/baseTypes/ObjectTypeBase';
import { MediaTypeEnum, MediaVideoContentTypeEnum } from 'constants-media';
import { PropertiesInterface } from '../../types/properties/Property';
import { TypeContextEnum } from '../../types/properties/TypeContextEnum';
import Types from '../Types';
import { TYPE_GROUP_LANE } from '../constants';
import createShapeFromProperties from '../createShapeFromProperties';

const properties: PropertiesInterface = {
  _id: {
    type: 'UUID',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
  type: {
    type: 'String',
    default: MediaTypeEnum.Video,
    validators: [
      {
        name: 'In',
        value: [MediaTypeEnum.Video],
      },
    ],
  },
  contentType: {
    type: 'String',
    validators: [
      {
        name: 'In',
        value: Object.values(MediaVideoContentTypeEnum),
      },
    ],
  },
};

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use VideoType from application-types instead.
 */
export class VideoType extends ObjectTypeBase {
  group = TYPE_GROUP_LANE;

  name = 'Video';

  friendlyName = 'Video';

  contexts = [TypeContextEnum.Block, TypeContextEnum.Content];

  get default(): any {
    return {
      _id: null,
    };
  }

  buildSchema() {
    return yup
      .object()
      .nullable()
      .default(null)
      .shape(createShapeFromProperties(properties));
  }

  properties = properties;
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use Video from application-types instead.
 */
const definition = new VideoType();

Types.addBaseType(definition);
export default definition;
